import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Nav from './Nav';
import HomePage from './HomePage';
import SkuFamilyLiveInvPage from './SkuFamilyLiveInvPage';
import InventoryMgmtPage from './InventoryMgmtPage';
import InventoryMgmtConfig from './InventoryMgmtConfig';
import LoginPage from './LoginPage';
import DraftOrdersPage from './DraftOrdersPage';
import DistDiscountsConfig from './DistDiscountsConfig';
import DistPoMappingConfig from './DistPoMappingConfig';
import DistCartonConversionsConfig from './DistCartonConversionsConfig';
import DistPendingConversionsPage from './DistPendingConversionsPage';
import PackiyoOrderingPage from './PackiyoOrderingPage';
import ZeroLocationPage from './ZeroLocationPage';
import EuFulfillmentPage from './EuFulfillmentPage';
import DangerZonePage from './DangerZonePage';
import WikiPage from './WikiPage';
import MarkitdownPage from './MarkitdownPage';
import WholesaleApplicationsPage from './WholesaleApplicationsPage';
import WholesaleDiscountsPage from './WholesaleDiscountsPage';
import KpiReportPage from './KpiReportPage';
import OrderMatrixPage from './OrderMatrixPage';
import LocationOrdersPage from './LocationOrdersPage';
import { EMBEDDED } from './shopifyEmbed';
import './App.css';

export default function App() {
  const [user,        setUser]        = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (EMBEDDED) return;
    axios.get('/api/auth/me', { withCredentials: true })
      .then(r => { setUser(r.data); setAuthLoading(false); })
      .catch(() => { setUser(null); setAuthLoading(false); });
  }, []);

  // Inside the Shopify admin (/shopify/app): just the order tool, authenticated
  // by App Bridge ID tokens rather than the Google login.
  if (EMBEDDED) {
    return <LocationOrdersPage />;
  }

  if (authLoading) {
    return <div style={{ minHeight: '100vh', background: '#080b12' }} />;
  }

  // If auth is disabled (no Google OAuth configured) OR user is logged in, show the app
  if (!user || (!user.auth_disabled && !user.email)) {
    return <LoginPage />;
  }

  return (
    <>
      <Nav user={user} />
      <main className="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Classic (non-live) SKU Family tool was retired — keep old links/bookmarks working. */}
          <Route path="/sku-family-inv/*" element={<Navigate to="/sku-family-live" replace />} />
          <Route path="/sku-family-live" element={<SkuFamilyLiveInvPage />} />
          <Route path="/inventory-management" element={<InventoryMgmtPage />} />
          <Route path="/inventory-management/config" element={<InventoryMgmtConfig />} />
          <Route path="/draft-orders" element={<DraftOrdersPage />} />
          <Route path="/location-orders" element={<LocationOrdersPage />} />
          <Route path="/draft-orders/config" element={<DistDiscountsConfig />} />
          <Route path="/draft-orders/po-mapping" element={<DistPoMappingConfig />} />
          <Route path="/draft-orders/carton-conversions" element={<DistCartonConversionsConfig />} />
          <Route path="/draft-orders/pending-conversion" element={<DistPendingConversionsPage />} />
          <Route path="/packiyo-ordering" element={<PackiyoOrderingPage />} />
          <Route path="/eu-fulfillment" element={<EuFulfillmentPage />} />
          <Route path="/danger-zone" element={<DangerZonePage />} />
          <Route path="/zero-location" element={<ZeroLocationPage />} />
          <Route path="/wiki" element={<WikiPage />} />
          <Route path="/wiki/:slug" element={<WikiPage />} />
          <Route path="/markitdown" element={<MarkitdownPage />} />
          <Route path="/wholesale/applications" element={<WholesaleApplicationsPage />} />
          <Route path="/wholesale/applications/:appId" element={<WholesaleApplicationsPage />} />
          <Route path="/wholesale/discounts" element={<WholesaleDiscountsPage />} />
          <Route path="/kpi-report" element={<KpiReportPage />} />
          <Route path="/order-matrix" element={<OrderMatrixPage />} />
          <Route path="/order-matrix/:matrixId" element={<OrderMatrixPage />} />
        </Routes>
      </main>
    </>
  );
}
